import React from "react"
import MyCard from "@common-utils/MyCard"
import { useDashboardAlertesPeriodesEssaiExpirationListingContext } from "./DashboardAlertesConsultantAvecDocsEmbaucheNonEnvoyesListing"
import "./styles.scss"
import { IItemResponseModel } from "./core/_models"
import { toast } from "react-toastify"
import { Link } from "react-router-dom"
import { useQueryClient } from "react-query"
import EnvoyerOuIgnorerEnvoiDocEmbauche from "../../../../components/consultant/EnvoyerOuIgnorerEnvoiDocEmbauche"

/* Wrapper */
const Preview = () => {
     const queryClient = useQueryClient()
     const globalContext = useDashboardAlertesPeriodesEssaiExpirationListingContext()
     const selectedItemInPreview = globalContext.itemInPreview!.selectedItem
     const itemInPreview = globalContext.listingQuery.data?.data.find(item => item.consultant?.id === selectedItemInPreview.consultant?.id) as IItemResponseModel

     // useEffect(() => {
     //      detailsQuery.refetch()
     // }, [itemInPreview.consultant.id])

     return (
          <MyCard>
               <MyCard.Header isCollapseIconShown={false}>
                    Documents d'embauche de <Link to={`/business/consultants/${itemInPreview.consultant.id}/details`}>{itemInPreview.consultant.prenomNom}</Link>
               </MyCard.Header>
               <MyCard.Body noPadding styles={{ maxHeight: "75.1vh", overflowY: "scroll" }}>
                    <div className="mt-5" />
                    <EnvoyerOuIgnorerEnvoiDocEmbauche
                         key={itemInPreview.consultant.id}
                         consultant={itemInPreview.consultant}
                         onQueryFetched={() => globalContext.setItemInPreview(prev => (prev ? { ...prev, isSelectedItemLoading: false } : prev))}
                         onSuccessEnvoyerDocCallback={() => {
                              globalContext.setItemInPreview(null)
                              globalContext.listingQuery.refetch()
                              toast.success(`Les documents d'embauche ont bien été envoyés à ${itemInPreview.consultant.prenomNom}. Vous êtes en copie du mail.`)
                         }}
                         onSuccessIgnorerEnvoiDocCallback={() => {
                              globalContext.setItemInPreview(null)
                              globalContext.listingQuery.refetch()
                              toast.success(`Votre action a bien été prise en compte. L'alerte d'envoi concernant ${itemInPreview.consultant.prenomNom} a été supprimée.`)
                         }}
                    />
               </MyCard.Body>
          </MyCard>
     )
}

export default Preview
